import { render, staticRenderFns } from "./Deploy.vue?vue&type=template&id=65c573de&scoped=true&"
import script from "./Deploy.vue?vue&type=script&lang=ts&"
export * from "./Deploy.vue?vue&type=script&lang=ts&"
import style0 from "./Deploy.vue?vue&type=style&index=0&id=65c573de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c573de",
  null
  
)

export default component.exports